module.exports = __webpack_public_path__ + "static/media/nosql.e9ecdd4f.jpg";